var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralBacs = function SvgDAhuGeneralBacs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 46,
    width: 2,
    height: 8,
    fill: "#1C9D5B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 4.5,
    width: 41,
    height: 41,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,5v40h-40V5H362 M363,4h-42v42h42V4L363,4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342,10.4l15.2,12.9h-3.6v18.4h-23.2V23.3h-3.6L342,10.4 M342,8.7l-18.7,15.9h5.8V43h25.8V24.6h5.8L342,8.7L342,8.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.6,17l-1.5,0l0-0.8c0-1-0.3-1.8-0.9-2.2c-0.9-0.7-2.4-0.5-2.4-0.5l-0.7,0.1v-1.5l0.4-0.1c0.1,0,2.1-0.4,3.6,0.8 c0.9,0.7,1.4,1.8,1.4,3.3L355.6,17L355.6,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2,16.2V17h-1.5v-0.8c0-1.8-0.5-3.1-1.5-4c-1.7-1.5-4.3-1.1-4.4-1.1l-0.7,0.1V9.7l0.5-0.1c0.1,0,3.3-0.4,5.6,1.5 C357.5,12.3,358.2,14,358.2,16.2L358.2,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7,16.2V17h-1.5v-0.8c0-2.6-0.7-4.6-2.2-5.8c-2.4-2.1-6.1-1.7-6.2-1.7l-0.7,0.1V7.2l0.5-0.1c0.2,0,4.4-0.5,7.4,2.1 C359.8,10.8,360.7,13.2,360.7,16.2L360.7,16.2L360.7,16.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "325.9,7.1 323.4,14.5 325.1,14.5 323.3,21.5 329.1,11.5 326.5,11.4 328.6,7.1"
  })))));
};
export default SvgDAhuGeneralBacs;